import {
  CLEAR_REPORT_ANALYTICS,
  UPDATE_REPORT_ANALYTICS_PAGE_OPTIONS, FETCH_REPORT_ANALYTICS_ERROR, FETCH_REPORT_ANALYTICS_SUCCESS, FETCH_REPORT_ANALYTICS,
} from 'constants/ActionTypes';

/** Report Analytics */
export const fetchReportAnalytics = () => ({ type: FETCH_REPORT_ANALYTICS });
export const clearReportAnalytics = () => ({ type: CLEAR_REPORT_ANALYTICS });
export const fetchReportAnalyticsSuccess = (data) => ({ type: FETCH_REPORT_ANALYTICS_SUCCESS, data });
export const fetchReportAnalyticsFailure = (error) => ({ type: FETCH_REPORT_ANALYTICS_ERROR, error });

export const updateReportAnalyticsPageNumber = (pageNumber) => ({ type: UPDATE_REPORT_ANALYTICS_PAGE_OPTIONS, pageOptions: { pageNumber } });
export const updateReportAnalyticsPageSize = (pageSize) => ({ type: UPDATE_REPORT_ANALYTICS_PAGE_OPTIONS, pageOptions: { pageSize, pageNumber: 1 } });
